import { WidgetTypes } from "legacy/constants/WidgetConstants";
import type { FlattenedWidgetProps } from "legacy/reducers/entityReducers/canvasWidgetsReducer";

import { getWidgets } from "./entitiesSelector";
import { createMarkedSelector } from "./markedSelector";
import { getWidgetsMeta } from "./sagaSelectors";

export const getModalDropdownList = createMarkedSelector(
  "getModalDropdownList",
)(getWidgets, (widgets) => {
  const modalWidgets = Object.values(widgets).filter(
    (widget: FlattenedWidgetProps) =>
      widget.type === WidgetTypes.MODAL_WIDGET ||
      widget.type === WidgetTypes.SLIDEOUT_WIDGET,
  );
  if (modalWidgets.length === 0) return undefined;

  return modalWidgets.map((widget: FlattenedWidgetProps) => ({
    id: widget.widgetId,
    label: widget.widgetName,
    value: `${widget.widgetName}`,
  }));
});

export const getOpenModals = createMarkedSelector("getOpenModals")(
  getWidgets,
  getWidgetsMeta,
  (widgets, metaProps) => {
    return Object.values(widgets).filter(
      (widget: FlattenedWidgetProps) =>
        widget.type === WidgetTypes.MODAL_WIDGET &&
        metaProps[widget.widgetId]?.isVisible,
    );
  },
);

export const getOpenModalOrSlideout = createMarkedSelector(
  "getOpenModalOrSlideout",
)(getWidgets, getWidgetsMeta, (widgets, metaProps) => {
  return Object.values(widgets).find(
    (widget: FlattenedWidgetProps) =>
      (widget.type === WidgetTypes.MODAL_WIDGET ||
        widget.type === WidgetTypes.SLIDEOUT_WIDGET) &&
      metaProps[widget.widgetId]?.isVisible,
  );
});
